import { motion } from "framer-motion";
import { AMAZON_URL } from "@/config";

const Navbar = () => (
  <motion.header
    initial={{ y: -64, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#0A0A0A]/80 backdrop-blur-xl"
    data-testid="navbar"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <a href="#top" className="flex items-baseline gap-3" data-testid="nav-brand">
        <span className="font-serif-display text-lg tracking-wide text-white">
          High Somatic Mastery
        </span>
        <span className="hidden sm:inline font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#00FF8F]">
          Zero Cortisol
        </span>
      </a>
      <nav className="flex items-center gap-6 sm:gap-8">
        <a
          href="#access"
          className="hidden md:inline text-xs uppercase tracking-[0.2em] text-[#A6A6AD] hover:text-[#00FF8F] transition-colors duration-300"
          data-testid="nav-access-link"
        >
          The Protocol
        </a>
        <a
          href={AMAZON_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="neon-ghost-btn text-xs uppercase tracking-[0.18em] px-5 py-2.5 rounded-full"
          data-testid="nav-acquire-button"
        >
          Acquire the Book
        </a>
      </nav>
    </div>
  </motion.header>
);

export default Navbar;
